module.exports = __webpack_public_path__ + "img/card.63429f39.jpg";